import { render, staticRenderFns } from "./UcFixedAssetWorkItemsPanel.yaml?vue&type=template&id=bc261a4c&component"
import script from "./UcFixedAssetWorkItemsPanel.yaml?vue&type=script&lang=ts&component"
export * from "./UcFixedAssetWorkItemsPanel.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports